/**
 * @generated SignedSource<<c6f3389c00fdf80d73355e4c728f6937>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobilePromotion_transaction$data = {
  readonly promotions: ReadonlyArray<{
    readonly code: string | null;
    readonly isInvalid: boolean | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPromotionForm_transaction">;
  readonly " $fragmentType": "CheckoutMobilePromotion_transaction";
};
export type CheckoutMobilePromotion_transaction$key = {
  readonly " $data"?: CheckoutMobilePromotion_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobilePromotion_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobilePromotion_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPromotionForm_transaction"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "promotions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInvalid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "a36820386b688fa2020a858ff7a2240c";

export default node;
